import {useState } from "react";
import { Typography, InputBase, Avatar, IconButton } from "@mui/material";
import Scrollbars from "rc-scrollbars";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import SendIcon from '@mui/icons-material/Send';
import AddIcon from '@mui/icons-material/Add';

import avatarTest from '../../images/others/avatar.png';

export default function Chat({data}){
  const [story, setStory] = useState(data?.story || [])
  const [users, setUsers] = useState(data?.users || [])//todo добавление первых двух юзеров?
  const [text, setText] = useState("")



  const addMes = () => {
    //todo получать время по utc
    //как получить юзера?

    let mes = {date: new Date(), content: {text: text}, user: {id:1, avatar:avatarTest}}
    setStory([...story, mes])
    setText("")
  }



  return (
    <div
      style={{
        height: '80%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}
    >
      
      <div 
        style={{ 
          padding: "1%",
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between', 
          alignItems: "center"}}>
          <div
            style={{ 
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: "center" }}>
            <Typography variant="h5" style={{ marginLeft: 10 }}>
              {'Участники'}
            </Typography>
            {users?.map((user) => (
              <Avatar src={user.avatar}></Avatar>
            ))}
          </div>
          <IconButton aria-label="delete">
            <AddIcon/>
        </IconButton>
      </div>
      <Scrollbars
        autoHeight autoHeightMax={'65vh'}
        autoHide={true}
        style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column"}}  
      >
        {story?.map((el) => (
          <ChatMes user={el.user} content={el.content} date={el.date}/>
        ))}
      </Scrollbars>
      <div style={{display: 'flex', justifyContent: "flex-start", flexDirection: "row", alignItems: "center"}}>
        <IconButton aria-label="delete">
          <AttachFileIcon />
        </IconButton>
        <>
          <InputBase
            sx={{ ml: 1, flex: 1, borderRadius: '1em' }}
            placeholder="Введите сообщение"
            value={text}
            onChange={(event) => {setText(event.target.value)}}
            multiline={true}
          />
          <IconButton
            color="primary"
            sx={{ p: '10px' }}
            onClick={addMes}
          >
            <SendIcon/>
          </IconButton>
        </>
      </div>
    </div>
  );
  
}

function ChatMes({user, content, date}) {
  //todo добавить разные виды контента, которые можно отображать 
  return (
    <div style={{margin: "5%", display: 'flex', justifyContent: "flex-start", flexDirection: "column"}}>
      <div style={{display: 'flex', justifyContent: "flex-start", flexDirection: "row", alignItems: "center"}}>
        {user.avatar && <Avatar style={{width: "25px", height: "25px"}} src={user.avatar}></Avatar>}
        <Typography variant="h6" style={{ marginLeft: 10, }}>
            {user.name}
        </Typography>
        <Typography variant="body2" style={{ marginLeft: 10, }}>
            {date.toLocaleString()}
        </Typography>
      </div>
      <div style={{display: 'flex', justifyContent: "flex-start", flexDirection: "column"}}>
        <div style={{ margin: 10, }}>
          {content.text.split('\n').map((el) => (
            <Typography variant="h6" >
              {el}
            </Typography>
        ))}
        </div>
      </div>
    </div>
  )
}